module.exports = __webpack_public_path__ + "media/favicons/apple-touch-icon-3a3db054.png";